import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { OrdeDtails } from '../pages/order-details';
import Orders from './orders';

const NewOrders = () => {
    const search = useLocation().search;
    const orderId = new URLSearchParams(search).get('order_id');
    return (
        (orderId) ? <OrdeDtails /> : <Orders />
    )
}

export default NewOrders;